import { reactive, readonly, watch } from 'vue';
import { showGlobalCampus, campus } from './global-campus.vue';

export default {
  install(application) {
    application.provide('campus', readonly(campus));
    const { store } = application.config.globalProperties;
    const campusDetail = reactive([]);
    watch(campus, (list) => {
      campusDetail.length = 0;
      campusDetail.push(...list.map((id) => store.globalCampusList.value.find((item) => item.id === id)));
    });
    application.provide('campus-obj', readonly(campusDetail));
    application.provide('showGlobalCampus', showGlobalCampus);
  },
};
